export const getAttributeLabel = (attributes, attributeName) => {
  return attributes.filter((attr) => attr.name === attributeName)[0]?.value?.label ?? undefined;
};

export const LOCALE = 'en-US'; //TODO: Need to get the locale from env var
